import type { Rebate } from '@urbanx/agx.agencies.client';
import { AgxSpacer, AgxTextInput, AgxTypography } from '@urbanx/agx.ui-components2';
import { LineItemRow } from './LineItems';
import { rebateFields } from './rebateFields';

export const ReadOnlyRebates = ({ rebates }: { rebates: Rebate[] }) => (
  <AgxSpacer gap="spacing-lg" fill>
    {rebates.length === 0 && <AgxTypography>No rebates</AgxTypography>}
    {rebates.map((rebate, index) => (
      <LineItemRow
        key={index}
        label={`Agency rebate ${index + 1}`}
        fields={rebateFields.map(({ name, label }) => (
          <AgxTextInput
            key={name}
            id={`agency-rebate-${index}-${name}`}
            type="text"
            label={label}
            defaultValue={rebate[name]}
            disabled
            hideOptionalText
            stretch
          />
        ))}
      />
    ))}
  </AgxSpacer>
);
